import React, { useState, useEffect, useContext } from "react";
import "../../Styles/OrderDownload.css";
import { MedicalContext } from "../../Components/Context/MedicalContext";
import FirmaOficial from "../../Photos/firma.png"
import PhoneIcon from "../../Photos/PhoneIcon.png"
import EmailIcon from "../../Photos/EmailIcon.png"
import { BasketContext } from '../Context/BasketContext';
import { Packs } from '../Context/PacksContext';
import ConfettiExplosion from "react-confetti-explosion";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { Modal } from 'flowbite-react';
import examslist from "../../../JSONS/updatedExams.json"
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode }  from 'jwt-decode';
import Logo from "../../Photos/YMC_Logo_PDF.png";
import TinyLogo from "../../Photos/YMCTinyLogo.svg";
import IconLab from "../../Photos/IconLaboratory.svg";
import IconIma from "../../Photos/IconImagenology.svg";
import IconDer from "../../Photos/IconDerivations.svg";

const OrderDownloadCreator = () => {

    const Navigate = useNavigate();

    const {
        OrderExamsCodes, Discounted
    } = useContext(BasketContext);

    const {
        Purchased, Added, SetAdded, BasketPacks, ExamsPerProduct
    } = useContext(Packs);

    const {
        RelatedExams
    } = useContext(MedicalContext);

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const Name = decodedToken ? decodedToken.name : null
    const Rut = decodedToken ? decodedToken.rut : null
    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();

        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();

        if (age > 15) {
            if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
                return age;
            } else {
                return age-1;
            }
        } else if (age === 15) {
            if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
                return age;
            }
        }

        return false;
    }
    const Age = DoB ? AgeCalc() : 0

    const [Loading, setLoading] = useState(false);
    const [LoadingImages, setLoadingImages] = useState(false);
    const [LoadingImage1, setLoadingImage1] = useState(false);
    const [LoadingImage2, setLoadingImage2] = useState(false);

    useEffect(() => {
      if(localStorage.getItem("OrderExamsCodes") === null || Object.keys(OrderExamsCodes).length === 0 || Purchased === false) {
        Navigate("/orden-medica")
      } else {
        if(OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Imagenología' | examslist[Item].emission === 'Procedimientos').length > 32 || OrderExamsCodes.filter((Item) => examslist[Item].emission === "Laboratorio").length > 32) {
          Navigate("/orden-medica")
        } else if(!Added) {
          uploadOrder()
          SetAdded(true)
        }
      }
    })

    useEffect(() => {
        if(LoadingImage1 && LoadingImage2) {
        setLoadingImages(false)
        setLoadingImage1(false)
        setLoadingImage2(false)
        }
    }, [LoadingImage1, LoadingImage2])

    //const UserAge = new Date().getFullYear() - new Date(DoB).getFullYear();

    const DateMedical = new Date();
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"];
    const DateFormatted = (new Intl.DateTimeFormat(['ban', 'id']).format(DateMedical)).toString()
    //const month = DateMedical.getMonth() + 1;

    const [openModal, setOpenModal] = useState(false);
    const [orderChosen, setOrderChosen] = useState(false);
    const [HowMany, setHowMany] = useState(0);

    function PDFstuff() {
        const pdf = new jsPDF();

        let manyExams = 0
        if(orderChosen === "Imagenología y Procedimientos") {
        manyExams = OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length
        } else {
        manyExams = OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length
        }

        if(manyExams > 16) {
        Promise.all([
            html2canvas(document.getElementById('myPage'), { quality: 0.8 }),
            html2canvas(document.getElementById('myPage2'), { quality: 0.8 })
        ])
        .then(function([blob1,  blob2]) {
            let imgProps= pdf.getImageProperties(blob1);
            let pdfWidth = pdf.internal.pageSize.getWidth();
            let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(blob1, 'PNG', 0, 0,pdfWidth, pdfHeight);

            pdf.addPage()
            imgProps= pdf.getImageProperties(blob2);
            pdfWidth = pdf.internal.pageSize.getWidth();
            pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(blob2, 'PNG', 0, 0,pdfWidth, pdfHeight);
            pdf.save("Orden "+orderChosen+".pdf"); 
        });
        } else {
        html2canvas(document.getElementById('myPage'), { quality: 0.8 })
            .then(function (dataUrl) {
                const imgProps= pdf.getImageProperties(dataUrl);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(dataUrl, 0, 0,pdfWidth, pdfHeight);

                pdf.save("Orden "+orderChosen+".pdf"); 
            });
            }
    }

    async function uploadOrder() {
        setLoading(true)

        let payment = 0
        for(let i = 0; i<BasketPacks.length; i++) {
          payment += ExamsPerProduct[BasketPacks[i]].price
        }
    
        if(RelatedExams.length !== 0) {
          payment += 990
        }

        payment = payment * (100 - Discounted) / 100

        let params = {
          rut: Rut,
          age: Age,
          exams: OrderExamsCodes,
          discount: Discounted,
          price: payment
        };
        
        let requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(params)
        };
        
        try{
            
          const resp = await fetch("https://ymc-doc-api.azurewebsites.net/save_user_order", requestOptions)
          if (resp.status !== 200){
              alert("there has been some error");
              return false;
          }
          const data = await resp.json();
          if(data.acknowledged) {
              setLoading(false)
          } else {
              setLoading(false)
              console.log(data)
              return false
          }
        } catch(error){
            //MySwal.fire({
            //  icon: "error",
            //  title: "Ocurrió un error al procesar el pago",
            //  text: "Por favor inténtelo más tarde",
            //  showConfirmButton: true
            //});
            console.log(error)
            setLoading(false)
            return false
        }
    }
    

    return (
    <>
    {Object.keys(OrderExamsCodes).length === 0 || OrderExamsCodes === null || Loading ?
    <div className="OrderCheckoutOuterDiv">
      <div className="UserProfileInnerDiv" style={{paddingInline:"2%"}}>
        <div className='UserProfileInnerDivCalculatorWhiteBlock2' id="FullForm" style={{color:"#330066"}}>
          <div className="OrderDownloadCreator">
            <h1 className="ThankYouMessage mt-5">
              Cargando Orden Médica
            </h1>
            <div className="OrderDownloadCreatorSpinner"></div>
          </div>
        </div>
      </div>
    </div>
    :
    <div className="OrderCheckoutOuterDiv">
    <div className="UserProfileInnerDiv">
     <div className='UserProfileInnerDivCalculatorWhiteBlock' id="FullForm" style={{color:"#330066", minHeight:"420px"}}>
      <div className="OrderDownloadCreator">
      <div className='UserWelcomeBlockPageWideFlex'>
      <div className='UserWelcomeBlockPageWideSideL OrderDownloadCreatorSideL'>
        <div className='UserWelcomeBlockPage1TitleFlex' style={{marginBlockStart:"0px"}}>
          <div className='UserWelcomeBlockPage1Title' style={{marginInline:"auto"}}>Órdenes Médicas</div>
        </div>
        <div className="OrderDownloadCreatorUpperFlex">
          <div className="OrderDownloadCreatorUpperLeft">
            <h2 className="ThankYouMessage">
              Tu orden de exámenes <span style={{fontStyle:"italic",fontWeight:"800"}}>ha sido creada con éxito</span>
            </h2>
          </div>
          <img alt="" className="OrderDownloadCreatorUpperRight" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
        </div>
        </div>
        <div className='UserWelcomeBlockPageWideSideR OrderDownloadCreatorSideR'>
        <ConfettiExplosion className="Confetti" />
        <div className="OrderDownloadCreatorLowerFlex">
          {OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Laboratorio').length > 0 ?
          <div className="OrderDownloadCreatorLowerBlock">
            <div className="OrderDownloadCreatorLowerBlockTexts">
              <img alt="" className="OrderDownloadCreatorLowerBlockIcon" src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamLaboratoryIcon.svg" />
              <h4 className="OrderDownloadCreatorLowerBlockTitle">Laboratorio</h4>
            </div>
            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" style={{width:"100%"}} onClick={() => {setOrderChosen('Laboratorio'); setOpenModal(true); setLoadingImages(true); setHowMany(OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Laboratorio').length);}}>
                <div className="GeneralPurpleButtonText">Descargar</div>
                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
            </div>
          </div>
          : null}
          {OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Imagenología' | examslist[Item].emission === 'Procedimientos').length > 0 ?
          <div className="OrderDownloadCreatorLowerBlock">
            <div className="OrderDownloadCreatorLowerBlockTexts">
              <img alt="" className="OrderDownloadCreatorLowerBlockIcon" src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamImagenologyIcon.svg" />
              <h4 className="OrderDownloadCreatorLowerBlockTitle">Imagenología y procedimientos</h4>
            </div>
            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" style={{width:"100%"}} onClick={() => {setOrderChosen('Imagenología y Procedimientos'); setOpenModal(true); setLoadingImages(true); setHowMany(OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length);}}>
                <div className="GeneralPurpleButtonText">Descargar</div>
                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
            </div>
          </div>
          : null}
          {OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Derivaciones').length > 0 ?
          <div className="OrderDownloadCreatorLowerBlock">
            <div className="OrderDownloadCreatorLowerBlockTexts">
              <img alt="" className="OrderDownloadCreatorLowerBlockIcon" src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamDerivationsIcon.svg" />
              <h4 className="OrderDownloadCreatorLowerBlockTitle">Derivaciones</h4>
            </div>
            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" style={{width:"100%"}} onClick={() => {setOrderChosen('Derivaciones'); setOpenModal(true); setLoadingImages(true); setHowMany(OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Derivaciones').length);}}>
                <div className="GeneralPurpleButtonText">Descargar</div>
                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
            </div>
          </div>
          : null}
        </div>
        </div>
        </div>
        <Modal dismissible show={openModal} position="center" className='OrderDownloadPreviewModal'>
            <Modal.Body className='OrderDownloadPreviewModalBody'>
              <div className='OrderDownloadPreviewModalHeaderTitle'>Preview Orden Médica {orderChosen}</div>
              <div className='OrderDownloadPreviewModalHeaderButtons'>
                {LoadingImages ? 
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalDownloadButton">Cargando...</div>
                :
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalDownloadButton" onClick={() => PDFstuff()}>DESCARGAR</div>
}
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
              </div>
              <div className="OrderDownloadPreviewModalPDFContainer">
                <div id="myPage" className="OrderDownloadPreviewModalPDF">
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockEnd:"12px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <div className="OrderDownloadPreviewModalPDFUpperLeftSidePageNumber">1/{HowMany > 16 ? 2 : 1}</div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <img className="OrderDownloadPreviewModalPDFUpperRightLogo" alt='' src={TinyLogo} onLoad={() => setLoadingImage1(true)}/>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockStart:"8px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <h2 className="OrderDownloadPreviewModalPDFUpperUpperLeftTitle">Orden Médica {orderChosen}</h2>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightOrderText">Fecha de emisión</div>
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightText1">{DateMedical.getDate()} de {months[DateMedical.getMonth()]} {DateMedical.getFullYear()}</div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine"></div>
                  <div className="OrderDownloadPreviewModalPDFPatientData">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle" style={{marginBlock:"10px"}}>Paciente</div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataName">
                      Nombre: {Name}
                    </div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataSecondRow">
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Rut: {Rut}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Edad: {Age}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Sexo: {Gender === 1 ? 'Hombre' : 'Mujer'}
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine" style={{paddingBlockEnd:"8px"}}></div>
                  {orderChosen === "Imagenología y Procedimientos" ?
                  <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">Exámenes {orderChosen}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={IconIma} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length).keys()].map((object) => {
                      return (
                    <>
                    {object < 16 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep === "No necesita preparación" ? null : "Preparación: "}{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
                    :
                    <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">{orderChosen === "Derivaciones" ? "Derivaciones" : "Exámenes Laboratorio"}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={orderChosen === "Derivaciones" ? IconDer : IconLab} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                      {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length).keys()].map((object) => {
                        return (
                      <>
                      {object < 16 ?
                      <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                        <div>
                          <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                            {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].name}</div>
                          <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep === "No necesita preparación" ? null : "Preparación: "}{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep} </div>
                        </div>
                      </div>
                      : null}
                      </>
  )})}
                    </div>
                    </div>
                    </>
}
                  <div className="OrderDownloadPreviewModalPDFSignatureDiv">
                    <img className="OrderDownloadPreviewModalPDFSignatureImage" alt='' src={FirmaOficial} onLoad={() => setLoadingImage2(true)}/>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >Jorge Caro Díaz</div>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >Médico-Cirujano</div>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >RUT: 15.946.308-7&emsp;RCM: 27978-1</div>
                    
                  </div>
                  <div className="OrderDownloadPreviewModalPDFContactDiv">
                    <div className="OrderDownloadPreviewModalPDFContactFlex">
                      <div className="OrderDownloadPreviewModalPDFContactLeft">
                        <img className="OrderDownloadPreviewModalPDFContactLeftLogo" alt='' src={Logo} />
                      </div>
                      <div className="OrderDownloadPreviewModalPDFContactRight">
                        <div className="OrderDownloadPreviewModalPDFContactText">En caso de dudas o consultas, <span style={{fontWeight:"700"}}>contáctanos</span></div>
                        <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                          <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={PhoneIcon} />
                          <div className="OrderDownloadPreviewModalPDFContactLowerText">+56 9 7127 3898 </div>
                        </div>
                        <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                          <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={EmailIcon} />
                          <div className="OrderDownloadPreviewModalPDFContactLowerText">contacto@yomecontrolo.cl </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {HowMany > 16 ? 
              <div className="OrderDownloadPreviewModalPDFContainer">
              <div id="myPage2" className="OrderDownloadPreviewModalPDF">
              <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockEnd:"12px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <div className="OrderDownloadPreviewModalPDFUpperLeftSidePageNumber">2/{HowMany > 16 ? 2 : 1}</div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <img className="OrderDownloadPreviewModalPDFUpperRightLogo" alt='' src={TinyLogo} onLoad={() => setLoadingImage1(true)}/>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockStart:"8px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <h2 className="OrderDownloadPreviewModalPDFUpperUpperLeftTitle">Orden Médica {orderChosen}</h2>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightOrderText">Fecha de emisión</div>
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightText1">{DateMedical.getDate()} de {months[DateMedical.getMonth()]} {DateMedical.getFullYear()}</div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine"></div>
                  <div className="OrderDownloadPreviewModalPDFPatientData">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle" style={{marginBlock:"10px"}}>Paciente</div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataName">
                      Nombre: {Name}
                    </div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataSecondRow">
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Rut: {Rut}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Edad: {Age}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Sexo: {Gender === 1 ? 'Hombre' : 'Mujer'}
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine" style={{paddingBlockEnd:"8px"}}></div>
                {orderChosen === "Imagenología y Procedimientos" ?
                  <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">Exámenes {orderChosen}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={IconIma} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length).keys()].map((object) => {
                      return (
                    <>
                    {object > 15 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
                    :
                    <>
                  <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle">{orderChosen === "Derivaciones" ? "Derivaciones" : "Exámenes Laboratorio"}</div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                      <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length})</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                        <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={orderChosen === "Derivaciones" ? IconDer : IconLab} />
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                  <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length).keys()].map((object) => {
                      return (
                    <>
                    {object > 15 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
}
                <div className="OrderDownloadPreviewModalPDFSignatureDiv">
                  <img className="OrderDownloadPreviewModalPDFSignatureImage" alt='' src={FirmaOficial}/>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >Jorge Caro Díaz</div>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >Médico-Cirujano</div>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >RUT: 15.946.308-7&emsp;RCM: 27978-1</div>
                </div>
                <div className="OrderDownloadPreviewModalPDFContactDiv">
                  <div className="OrderDownloadPreviewModalPDFContactFlex">
                    <div className="OrderDownloadPreviewModalPDFContactLeft">
                      <img className="OrderDownloadPreviewModalPDFContactLeftLogo" alt='' src={Logo} />
                    </div>
                    <div className="OrderDownloadPreviewModalPDFContactRight">
                      <div className="OrderDownloadPreviewModalPDFContactText">En caso de dudas o consultas, <span style={{fontWeight:"700"}}>contáctanos</span></div>
                      <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                        <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={PhoneIcon} />
                        <div className="OrderDownloadPreviewModalPDFContactLowerText">+56 9 7127 3898 </div>
                      </div>
                      <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                        <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={EmailIcon} />
                        <div className="OrderDownloadPreviewModalPDFContactLowerText">contacto@yomecontrolo.cl </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> : null
              }
            </Modal.Body>
            <Modal.Footer>
              <div className="OrderDownloadPreviewModalFooter">
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalFooterCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
              </div>
            </Modal.Footer>
        </Modal>
      </div>
      </div>
      </div>
      </div>
}
    </>
  );
};

export default OrderDownloadCreator;